import { limitFilter } from 'utils/generator-utils'

const ProductCategoryService = {

  /**
   * ! only used for ReactSelect
   * ? might refactor later since it's too long
   * Transform category options to use React Select group options.
   * default format:
   *
   * @example
   * const format[
   *   label: 'parent label (s)'
   *   options: [
   *      {
   *        value: 'value or id',
   *        label: 'label'
   *      },
   *      { ... }
   *   ],
   *   { ... }
   * ]
   *
   * @param {object[]} categories array of categories
   */
  formatToReactSelectOptions: (categories, gender) => {
    const map_gender_hash = {
      'male'   : 'Wanita',
      'female' : 'Pria'
    }
    gender                = map_gender_hash[gender]
    /**
     * transform array into object. set the id as the key of value for ease accessing.
     * @example
     * const format = {
     *  1: { id: 1, label: 'Tas', parent_id: null, ... },
     *  2: { id: 2, label: 'Tote Bag', parent_id: 1, ... },
     *  { ... }
     * }
     */
    const category_hash = categories.reduce((hash, obj) => {
      hash[obj.id] = obj
      return hash
    }, {})

    // Only get leaf categories
    const leaf_categories = categories.filter((category) => {
      const category_has_children = categories.some((child_category) => child_category.parent_id === category.id)
      return !category_has_children
    })

    // Only get non leaf categories
    const not_leaf_categories = categories.filter((category) => {
      const category_has_children = categories.some((child_category) => child_category.parent_id === category.id)
      return category_has_children
    })

    /**
     * combine non-leaf categories with its parent categories.
     * @example
     * const format = [
     *  { label: 'Tas', values: [1] },
     *  { label: "Pakaian", values: [11] },
     *  { label: "Pakaian - Dress", values: [11, 12] },
     *  { ... }
     * ]
     */
    const transformParentCategories = not_leaf_categories.map((category) => {
      const transformedCategory = {}

      let full_label = category.label
      let all_ids    = [ category.id ]
      let parent     = category_hash[category.parent_id]

      while (parent != null) {
        full_label = `${parent.label} - ${full_label}`
        all_ids.push(parent.id)
        parent = category_hash[parent.parent_id]
      }

      transformedCategory.label  = full_label
      transformedCategory.values = all_ids

      return transformedCategory
    })

    let groupedOptions = []

    /**
     * Final transform: append leaf categories to transformed parent categories
     * @example
     * const format[
     *   label: 'parent label (s)'
     *   options: [
     *      {
     *        value: 'value or id',
     *        label: 'label'
     *      },
     *      { ... }
     *   ],
     *   { ... }
     * ]
     */
    transformParentCategories.forEach((parent_category) => {
      if ( parent_category.label.includes(gender) ) {
        return
      }
      const child_categories = leaf_categories.filter((leaf_category) => leaf_category.parent_id === parent_category.values[0])
      if (child_categories.length > 0) {
        groupedOptions.push({
          label   : parent_category.label,
          options : child_categories.map((category) => (
            {
              value : category.id,
              label : category.label
            }
          ))
        })
      }
    })

    return groupedOptions
  },

  // Copy paste of formatToReactSelectOptions
  // - changes the option return value.
  formatToSelectOptions: (categories) => {
    /**
     * transform array into object. set the id as the key of value for ease accessing.
     * @example
     * const format = {
     *  1: { id: 1, label: 'Tas', parent_id: null, ... },
     *  2: { id: 2, label: 'Tote Bag', parent_id: 1, ... },
     *  { ... }
     * }
     */
    const category_hash = categories.reduce((hash, obj) => {
      hash[obj.id] = obj
      return hash
    }, {})

    // Only get leaf categories
    const leaf_categories = categories.filter((category) => {
      const category_has_children = categories.some((child_category) => child_category.parent_id === category.id)
      return !category_has_children
    })

    // Only get non leaf categories
    const not_leaf_categories = categories.filter((category) => {
      const category_has_children = categories.some((child_category) => child_category.parent_id === category.id)
      return category_has_children
    })

    /**
     * combine non-leaf categories with its parent categories.
     * @example
     * const format = [
     *  { label: 'Tas', values: [1] },
     *  { label: "Pakaian", values: [11] },
     *  { label: "Pakaian - Dress", values: [11, 12] },
     *  { ... }
     * ]
     */
    const transformParentCategories = not_leaf_categories.map((category) => {
      const transformedCategory = {}

      let full_label = category.label
      let all_ids    = [ category.id ]
      let parent     = category_hash[category.parent_id]

      while (parent != null) {
        full_label = `${parent.label} - ${full_label}`
        all_ids.push(parent.id)
        parent = category_hash[parent.parent_id]
      }

      transformedCategory.url    = full_label
      transformedCategory.values = all_ids

      return transformedCategory
    })

    let groupedOptions = []

    /**
     * Final transform: append leaf categories to transformed parent categories
     * @example
     * const format[
     *   label: 'parent label (s)'
     *   options: [
     *      {
     *        value: 'value or id',
     *        label: 'label'
     *      },
     *      { ... }
     *   ],
     *   { ... }
     * ]
     */

    transformParentCategories.forEach((parent_category) => {
      const child_categories = leaf_categories.filter((leaf_category) => leaf_category.parent_id === parent_category.values[0])
      if (child_categories.length > 0) {
        groupedOptions.push({
          url     : parent_category.url,
          options : child_categories.map((category) => ({
            ...category
          }))
        })
      }
    })

    return groupedOptions
  },

  /**
   * ! only used for ReactSelect
   * Filtering through group options.
   * If there's selected option, we add to filter group option with the group option label
   * @param {array} groupOption - returned value from  `formatToReactSelectOptions`
   * @param {string} inputValue - user type input value
   * @return [array] filtered group options
   * @example
   * given user type 'To', we got result:
   * [
   *   {
   *     label: Tas,
   *     options: [
   *       {
   *         label: 'Tote Bag',
   *         value: 1
   *       }
   *     ]
   *   },
   *   {
   *     label: Make Up,
   *     options: [
   *       {
   *         label: 'Tools',
   *         value: 11
   *       }
   *     ]
   *   }
   * ]
   */
  filteringGroupOptions: (groupOptions, inputValue) => {
    let filterGroupOptions = []

    groupOptions.forEach((groupOption) => {
      const selectedGroupOption = Array.from(
        limitFilter(
          groupOption.options,
          (option) => option.label.toLowerCase().includes(inputValue),
          20
        ))

      if (selectedGroupOption.length > 0) {
        filterGroupOptions.push({
          ...groupOption,
          options: selectedGroupOption
        })
      }
    })

    return filterGroupOptions
  },

  /**
   * Nests child categories in its parents
   * @param {Array<Object>} categories - { id, label, parent_id} cateogry endpoint model
   */
  groupByParent: (categories) => {
    // adds `children` categories to each parent category
    const parentCategories = categories.reduce( (hash,  category) => {
      hash[category.id] = hash[category.id]
        ? { ...category, children: hash[category.id]['children'] }
        : { ...category, children: [] }

      const parentId = category.parent_id || 0
      hash[parentId] = hash[parentId]
        ? (
          {
            ...hash[parentId],
            children: [ ...hash[parentId]['children'], category ]
          }
        )
        : { children: [ category ] }
      return hash
    }, {})

    // adds `ancestors` to each each parent category
    Object.keys(parentCategories).forEach( (id) => {
      let ancestors = []
      let parentId  = parentCategories[id].parent_id
      while (parentId != null) {
        ancestors.push(parentId)
        parentId = parentCategories[parentId].parent_id
      }
      parentCategories[id]['ancestors'] = ancestors
    })

    return parentCategories
  }
}

export default ProductCategoryService
